




































































import Vue from "vue";
import Component from "vue-class-component";
import { IUserProfile } from "@/store/user/models";
import { IUpdateUser, ICreateUser } from "@/store/user_admin/models";
import { UserAdmin } from "@/store";

const AddUserFormProps = Vue.extend({
  props: {
    user: {
      type: (Object as () => IUserProfile) || null,
    },
    activate: {
      type: Boolean,
      default: false,
    },
  },
});

@Component<AddUserForm>({
  watch: {
    user: function(newValue) {
      if (newValue) {
        this.fillForm(newValue);
        this.update = true;
      } else {
        this.update = false;
      }
    },
    dialog: function(newValue) {
      if (!newValue) {
        this.clearForm();
        this.$emit("finished");
      }
    },
    activate: function(newValue) {
      if (newValue && !this.dialog) {
        this.dialog = true;
      }
    },
  },
})
export default class AddUserForm extends AddUserFormProps {
  valid: boolean = true;
  dialog: boolean = false;
  passwordError: boolean = false;
  created: boolean = false;
  createError: boolean = false;
  timeout: number = 3000;
  userName: string = "";
  fullName: string = "";
  email: string = "";
  password: string = "";
  password2: string = "";
  isAdmin: boolean = false;
  update: boolean = false;

  userRules: any[] = [
    (v: string) => !!v || "Introduzca su usuario",
    (v: string) =>
      (v && v.length <= 10) || "El usuario debe tener menos de 10 caracteres",
  ];
  emailRules: any[] = [
    (v: string) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "El correo electrónico no es válido",
  ];

  validate() {
    (this.$refs.form as any).validate();
    // Si se introduce password se debe de validar que sean iguales
    this.password
      ? (this.passwordError = this.password != this.password2)
      : (this.passwordError = false);
  }
  fillForm(user: IUserProfile) {
    this.userName = user.username || "";
    this.fullName = user.full_name || "";
    this.email = user.email || "email@email.com";
    this.isAdmin = user.is_admin || false;
  }
  clearForm() {
    this.userName = "";
    this.fullName = "";
    this.email = "email@email.com";
    this.isAdmin = false;
    this.valid = true;
    (this.$refs.form as any).resetValidation();
  }
  send() {
    this.validate();
    if (this.valid && !this.passwordError) {
      //Se llama a patch en caso de ser una actualización
      if (this.update) {
        const updatedUser: IUpdateUser = {
          id: this.user.id,
          password: this.password || "",
          full_name: this.fullName || "",
          email: this.email,
          is_admin: this.isAdmin,
        };
        if (!updatedUser.password) {
          delete updatedUser.password;
        }
        UserAdmin.dispatch("patchUser", updatedUser)
          .then(() => {
            this.created = true;
            setTimeout(() => (this.dialog = false), 2000);
          })
          .catch((error) => {
            console.error(error);
            this.createError = true;
          });
      } else {
        const newUser: ICreateUser = {
          username: this.userName,
          password: this.password || "",
          full_name: this.fullName || "",
          email: this.email,
          is_admin: this.isAdmin,
        };
        UserAdmin.dispatch("createUser", newUser)
          .then(() => {
            this.created = true;
            setTimeout(() => (this.dialog = false), 2000);
          })
          .catch((error) => {
            console.error(error);
            this.createError = true;
          });
      }
    }
  }

  //computed
  get switchLabel() {
    return this.isAdmin ? "Administrador" : "Usuario";
  }
  get passwordRules() {
    return this.update
      ? []
      : [
          (v: string) => !!v || "Introduzca su contraseña",
          (v: string) =>
            (v && v.length >= 8) ||
            "La contraseña debe de tener al menos 8 caracteres",
        ];
  }
}
